<template>
  <div class="subscription-calendar-page">
    <el-card shadow="hover">
      <template slot="header">
        <div class="card-header">
          <span>随心订配送日历</span>
          <div class="header-actions">
            <el-button-group>
              <el-button size="small" icon="el-icon-arrow-left" @click="prevMonth">上月</el-button>
              <el-button size="small" disabled>{{ displayYear }}年{{ displayMonth }}月</el-button>
              <el-button size="small" icon="el-icon-arrow-right" @click="nextMonth">下月</el-button>
            </el-button-group>
            <span class="legend">
              <span class="legend-rest">休</span> 节假日/周六周日不配送
            </span>
          </div>
        </div>
      </template>

      <div class="calendar-wrapper">
        <table class="calendar-table">
          <thead>
            <tr>
              <th>日</th>
              <th>一</th>
              <th>二</th>
              <th>三</th>
              <th>四</th>
              <th>五</th>
              <th>六</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(week, wi) in calendarWeeks" :key="wi">
              <td
                v-for="(day, di) in week"
                :key="di"
                :class="[
                  'day-cell',
                  day ? (day.isRest ? 'rest' : 'work') : 'empty'
                ]"
              >
                <template v-if="day">
                  <span class="day-num">{{ day.day }}</span>
                  <span v-if="day.label" class="day-label">{{ day.label }}</span>
                </template>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="rules-tip">
        <p><strong>配送规则：</strong></p>
        <ul>
          <li>顾客下单后，<strong>从第二日开始</strong>出单配送（遇「休」顺延至下一工作日）；</li>
          <li><strong>周五下单</strong> → 下周一开始配送；</li>
          <li><strong>周六、周日下单</strong> → 下周一开始配送。</li>
        </ul>
      </div>
    </el-card>
  </div>
</template>

<script>
import { buildSubscriptionCalendar } from '../utils/calendarUtils';

export default {
  name: 'SubscriptionCalendar',
  data() {
    return {
      currentYear: 2026,
      currentMonth: 2
    };
  },
  computed: {
    displayYear() {
      return this.currentYear;
    },
    displayMonth() {
      return this.currentMonth + 1;
    },
    calendarDays() {
      return buildSubscriptionCalendar(this.currentYear, this.currentMonth);
    },
    calendarWeeks() {
      const days = this.calendarDays;
      const first = new Date(this.currentYear, this.currentMonth, 1);
      let startOffset = first.getDay();
      const weeks = [];
      let week = [];
      for (let i = 0; i < startOffset; i++) {
        week.push(null);
      }
      days.forEach(d => {
        week.push(d);
        if (week.length === 7) {
          weeks.push(week);
          week = [];
        }
      });
      if (week.length) {
        while (week.length < 7) week.push(null);
        weeks.push(week);
      }
      return weeks;
    }
  },
  mounted() {
    const now = new Date();
    this.currentYear = now.getFullYear();
    this.currentMonth = now.getMonth();
  },
  methods: {
    prevMonth() {
      if (this.currentMonth === 0) {
        this.currentYear--;
        this.currentMonth = 11;
      } else {
        this.currentMonth--;
      }
    },
    nextMonth() {
      if (this.currentMonth === 11) {
        this.currentYear++;
        this.currentMonth = 0;
      } else {
        this.currentMonth++;
      }
    }
  }
};
</script>

<style scoped>
.subscription-calendar-page {
  padding: 20px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 16px;
}

.legend {
  font-size: 13px;
  color: #606266;
}

.legend-rest {
  display: inline-block;
  padding: 2px 6px;
  background: #f56c6c;
  color: #fff;
  border-radius: 4px;
  margin-right: 6px;
}

.calendar-wrapper {
  overflow-x: auto;
}

.calendar-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
}

.calendar-table th,
.calendar-table td {
  border: 1px solid #ebeef5;
  padding: 10px;
  text-align: center;
  min-width: 60px;
}

.calendar-table th {
  background: #f5f7fa;
  color: #606266;
  font-weight: 600;
}

.day-cell {
  vertical-align: middle;
}

.day-cell.work {
  background: #fff;
}

.day-cell.rest {
  background: #fef0f0;
  color: #f56c6c;
}

.day-cell.rest .day-label {
  display: inline-block;
  margin-left: 4px;
  font-weight: 600;
}

.day-cell.empty {
  background: #fafafa;
}

.day-num {
  font-size: 14px;
}

.rules-tip {
  margin-top: 24px;
  padding: 16px;
  background: #f4f4f5;
  border-radius: 6px;
  font-size: 13px;
  color: #606266;
}

.rules-tip ul {
  margin: 8px 0 0 0;
  padding-left: 20px;
}
</style>
